import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  async getAll () {
    Logger.info('Started the get all states process!')
    return tmxApiCall('get', '/states')
  }
}
